export enum MAPTILES {
  ORTOKARTTA = 'ortokartta',
  KANTAKARTTA = 'kantakartta',
}
